export const getDisparityColor = (value: number): string => {
  if (value === 0) {
    return '#757575';
  }
  if (value <= 1.0) {
    return '#25855a';
  } else if (value <= 2.0) {
    return '#ecc94b';
  } else {
    return '#e53e3e';
  }
};
